import React, { useReducer } from "react";
import PropTypes from "prop-types";
import Context from "./context";
import Reducer from "./reducer";
import {
  SET_LOADING,
  SET_NEWSLETTERS,
  SET_ERROR,
  SET_EVENTS,
  SET_FUNDING,
  SET_MEMOS
} from "./types";

const UpdatesState = props => {
  const initialState = {
    loading: true,
    error: null,
    newsletters: [],
    memos: [],
    events: [],
    funding: []
  };
  const init = initialState => ({ ...initialState });
  const [state, dispatch] = useReducer(Reducer, initialState, init);

  const getMemos = async () => {
    setLoading();
    try {
      const res = await fetch(
        `${process.env.GATSBY_STATIC_BASE_URL}/steering-committee-memos/steering-committee-memos.json`,
        { cache: "no-cache" }
      );
      const json = await res.json();
      dispatch({
        type: SET_MEMOS,
        payload: json
      });
    } catch (err) {
      console.error("Error getting resources: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading memos. Please try again later."
      });
    }
  };

  const getNewsletters = async () => {
    setLoading();
    try {
      const res = await fetch(
        `${process.env.GATSBY_STATIC_BASE_URL}/newsletters/newsletters.json`,
        { cache: "no-cache" }
      );
      const json = await res.json();
      dispatch({
        type: SET_NEWSLETTERS,
        payload: json
      });
    } catch (err) {
      console.error("Error getting resources: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading newsletters. Please try again later."
      });
    }
  };

  const getEvents = async () => {
    setLoading();
    try {
      const res = await fetch(
        `${process.env.GATSBY_STATIC_BASE_URL}/events/events.json`,
        { cache: "no-cache" }
      );
      const json = await res.json();
      dispatch({
        type: SET_EVENTS,
        payload: json
      });
    } catch (err) {
      console.error("Error getting events: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading newsletters. Please try again later."
      });
    }
  };

  const getFunding = async () => {
    setLoading();
    try {
      const res = await fetch(
        `${process.env.GATSBY_STATIC_BASE_URL}/funding/funding.json`,
        { cache: "no-cache" }
      );
      const json = await res.json();
      dispatch({
        type: SET_FUNDING,
        payload: json
      });
    } catch (err) {
      console.error("Error getting funding: ", err);
      dispatch({
        type: SET_ERROR,
        payload:
          "Sorry, there was an issue loading the list of funding opportunities. Please try again later."
      });
    }
  };

  const setLoading = async () => dispatch({ type: SET_LOADING });

  return (
    <Context.Provider
      value={{
        loading: state.loading,
        newsletters: state.newsletters,
        events: state.events,
        funding: state.funding,
        memos: state.memos,
        getNewsletters,
        getEvents,
        getFunding,
        getMemos,
        ...props.value
      }}
    >
      {props.children}
    </Context.Provider>
  );
};

UpdatesState.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object
};

export default UpdatesState;
